<template>
    <DashboardEditSection class="OwnerForm" title="Owner">
        <template v-if="user">
            <FormInput v-model="user.email" label="Email"/>
            <Row>
                <Column :md="6">
                    <FormInput v-model="user.firstName" label="First Name"/>
                </Column>
                <Column :md="6">
                    <FormInput v-model="user.lastName" label="Last Name"/>
                </Column>
            </Row>
            <FormInput v-model="user.phone" label="Phone"/>
            <AddressForm
                :address.sync="user.address"
                :city.sync="user.city"
                :state.sync="user.state"
                :zip.sync="user.zip"
            />

            <Button class="saveBtn primary" @click="handleSave" :disabled="submitPending">Save</Button>
        </template>
        <template v-else>
            <h2>Loading Company Owner...</h2>
        </template>
    </DashboardEditSection>
</template>


<script>
import * as api from '@/api';
import { mapGetters } from 'vuex';
import DashboardEditSection from '@/components/DashboardEditSection';
import AddressForm from '@/components/form/AddressForm';

export default {
    name: 'OwnerForm',

    components: { DashboardEditSection, AddressForm },

    computed: {
        ...mapGetters('auth', ['company']),
    },

    data: () => ({
        user: null,
        submitPending: false,
        submitError: null,
    }),

    mounted() {
        this.fetchOwner();
    },

    methods: {
        async fetchOwner() {
            this.fetchPending = true;
            const res = await api.getCompanyOwner(this.company.id);
            this.fetchPending = false;

            if (res.error) {
                this.fetchError = res.error;
                return this.$awn.alert('Failed to fetch owner');
            }

            this.user = res.body;
        },

        async handleSave() {
            if (this.submitPending) return;

            this.submitPending = true;
            const res = await api.updateUser(this.user);
            this.submitPending = false;

            if (res.error) {
                this.submitError = res.error;
                return this.$awn.alert('Failed to company owner');
            }

            this.user = res.body;
            this.$awn.success('Company owner has been updated');
        },
    },
};
</script>


<style lang="scss" scoped>
@import 'globals.scss';
.OwnerForm {
    .saveBtn {
        display: block;
        margin-left: auto;
    }
}
</style>
